import { Box, Grid, InputLabel, TextField, Button, FormControl, Select, MenuItem, FormHelperText, FormControlLabel, Checkbox, Typography, useTheme, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from "@mui/material"
import { useForm, Controller } from "react-hook-form";
import { useScheduled } from "../../../../shared/context/scheduledContext"
import AddIcon from '@mui/icons-material/Add'
import { useState, useEffect } from "react"
import DeleteIcon from '@mui/icons-material/Delete'
import CancelIcon from '@mui/icons-material/Cancel'
import EditIcon from '@mui/icons-material/Edit'
import { useUtiles } from "../../../../shared/context/utilesContext"

export default function AddSubTaskComponent() {
    const { subtaskScheduled, setSubtaskScheduled, subtaskScheduledValue, setSubtaskScheduledValue, subtaskScheduledList, setSubtaskScheduledList, indexSubtaskScheduled, setIndexSubtaskScheduled, resetSubtaskScheduled } = useScheduled()
    const { generateRandomCode, restorePreviousComponent } = useUtiles()
    const { control } = useForm()

    const  theme = useTheme()








    const handleAddSubtask = (subtaskScheduled, indexSubtaskScheduled) => {
        // Remove options if type is not list
        const subtaskToSave = subtaskScheduled.type_field !== 'list'
            ? { ...subtaskScheduled, options: undefined }
            : subtaskScheduled;

        if (indexSubtaskScheduled !== undefined && indexSubtaskScheduled !== null) {
            // Actualizar una subtarea existente
            const newSubtaskList = [...subtaskScheduledList]
            newSubtaskList[indexSubtaskScheduled] = {
                ...subtaskScheduledList[indexSubtaskScheduled],
                ...subtaskToSave
            }
            setSubtaskScheduledList(newSubtaskList)
        } else {
            //generar un codigo para la subtarea
            const code = generateRandomCode()
            const order = subtaskScheduledList.length + 1
            // Agregar una nueva subtarea
            setSubtaskScheduledList([...subtaskScheduledList, { ...subtaskToSave, order, code }])
        }

        // Limpiar el formulario después de guardar
        resetSubtaskScheduled()
        restorePreviousComponent()
        setIndexSubtaskScheduled(null)
    }


    //Agregar opciones a la subtarea
    const [indexEditOption, setIndexEditOption] = useState(null)
    const handleAddOptionSubtask = (value, indexSubtaskScheduled) => {
        //manejar las opciones de la subtarea
        // si se edita (si hay indexEditOption) se actualiza el valor de la opción
        // si no se edita se agrega una nueva opción
        const options = subtaskScheduled.options || []
        if (indexEditOption !== null) {
            options[indexEditOption] = { value }
        } else {
            options.push({ value })
        }

        if (indexSubtaskScheduled !== undefined) {
            // Si estamos editando una subtarea existente
            const newSubtaskList = [...subtaskScheduledList]
            newSubtaskList[indexSubtaskScheduled] = {
                ...newSubtaskList[indexSubtaskScheduled],
                options: [...options]
            }
            setSubtaskScheduledList(newSubtaskList)
        } else {
            // Si estamos creando una nueva subtarea
            setSubtaskScheduled({
                ...subtaskScheduled,
                options: [...options]
            })
        }

        // Reset the edit index after updating
        setIndexEditOption(null)
    }

    return (
        <Box sx={{
            padding: '20px',
        }}>
            <Grid container spacing={1}>

                <Grid item size={{ xs: 12, lg: 6 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Descripción de la subtarea</InputLabel>
                    <Controller
                        control={control}
                        name="description"
                        rules={{ required: 'La descripción es requerida' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Descripción de la subtarea"
                                error={!subtaskScheduled.description}
                                helperText={!subtaskScheduled.description ? 'La descripción es requerida' : ''}
                                onChange={(e) => setSubtaskScheduled({ ...subtaskScheduled, description: e.target.value })}
                                value={subtaskScheduled.description}
                            />
                        )}
                    />

                </Grid>
                <Grid item size={{ xs: 12, lg: 6 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Tipo de subtarea</InputLabel>
                    <FormControl fullWidth>
                        <Controller
                            control={control}
                            name="type_field"
                            rules={{ required: 'El tipo de subtarea es requerido' }}
                            render={({ field }) => (
                                <Select fullWidth placeholder="Tipo de subtarea"
                                    value={subtaskScheduled.type_field}
                                    onChange={(e) => setSubtaskScheduled({ ...subtaskScheduled, type_field: e.target.value })}
                                    error={!subtaskScheduled.type_field}
                                    helperText={!subtaskScheduled.type_field ? 'El tipo de subtarea es requerido' : ''}
                                >
                                    <MenuItem disabled>Selecciona un tipo de campo</MenuItem>
                                    <MenuItem value="text">Texto</MenuItem>
                                    <MenuItem value="number">Número</MenuItem>
                                    <MenuItem value="date">Fecha</MenuItem>
                                    <MenuItem value="boolean">Si/No</MenuItem>
                                    <MenuItem value="list">Lista</MenuItem>
                                    <MenuItem value="datetime-local">Fecha y hora</MenuItem>
                                </Select>
                            )}
                        />
                        <FormHelperText error={!subtaskScheduled.type_field ? 'El tipo de subtarea es requerido' : ''}>{!subtaskScheduled.type_field ? 'El tipo de subtarea es requerido' : ''}</FormHelperText>
                    </FormControl>

                </Grid>


                {subtaskScheduled.type_field === "list" && (
                    <Grid item size={{ xs: 12 }} sx={{ marginBottom: '20px' }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Agregar opciones</InputLabel>
                        <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px' }}>
                            <Controller
                                control={control}
                                name="value"
                                rules={{ required: 'El texto de la opción es requerido' }}
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        placeholder='Texto de la opción'
                                        value={subtaskScheduledValue.value || ''}
                                        onChange={(e) => setSubtaskScheduledValue({ ...subtaskScheduledValue, value: e.target.value })}
                                        helperText={!subtaskScheduledValue.value ? 'El texto de la opción es requerido' : ''}
                                        sx={{
                                            height: '40px',
                                        }}
                                    />
                                )}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                disabled={!subtaskScheduledValue.value}
                                onClick={() => {
                                    if (subtaskScheduledValue.value) {
                                        handleAddOptionSubtask(subtaskScheduledValue.value)
                                        setSubtaskScheduledValue({ ...subtaskScheduledValue, value: '' })
                                    }
                                }}
                                sx={{
                                    borderRadius: '50px',
                                    padding: '8px 25px',
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                    height: '40px',
                                }}
                            >
                                Agregar
                            </Button>
                        </Box>
                    </Grid>
                )}

                {
                    subtaskScheduled.type_field === "list" && (
                        <Grid item size={{ xs: 12 }} sx={{ marginTop: '20px' }}>
                            <TableContainer sx={{ maxHeight: 200, minHeight: "200px", width: '100%' }}>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Descripción de opción</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold'}}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {subtaskScheduled.options?.map((option, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{option.value}</TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', gap: '10px' }}>
                                                        <IconButton onClick={() => {
                                                            const newOptions = subtaskScheduled.options.filter((_, i) => i !== index)
                                                            setSubtaskScheduled({...subtaskScheduled, options: newOptions})
                                                        }}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                        <IconButton onClick={() => {
                                                            setIndexEditOption(index)
                                                            setSubtaskScheduledValue({...subtaskScheduledValue, value: option.value})
                                                        }}>
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    )
                }


                <Grid item size={{ xs: 12 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
                        <FormControlLabel checked={subtaskScheduled.is_mandatory} onChange={(e) => setSubtaskScheduled({ ...subtaskScheduled, is_mandatory: e.target.checked })} sx={{ marginLeft: '0px', '& .MuiFormControlLabel-label': { fontSize: '14px' } }} control={<Checkbox />} label="Obligatorio" />

                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            <Button onClick={() => restorePreviousComponent()} variant="contained" sx={{ backgroundColor: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }} startIcon={<CancelIcon />}>Cancelar</Button>
                            <Button onClick={() => handleAddSubtask(subtaskScheduled, indexSubtaskScheduled)} disabled={!subtaskScheduled.description || !subtaskScheduled.type_field || (subtaskScheduled.type_field === "list" && !subtaskScheduled.options?.length)} variant="contained" color="primary" startIcon={<AddIcon />}>
                            Guardar subtarea</Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>


        </Box>
    )
}